export default __webpack_public_path__ + "static/media/user.080c84e2.svg";